<template>
 <span>
    Account Statement sent to
    <router-link
      tag="a"
      :to="`/customers/view/${eventLog.customerId}`"
      >{{ eventLog.customerName }}</router-link
    >, outstanding balance
    <strong>{{ eventLog.balanceForward }}</strong>
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionAccountStatementSent',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
